import React from 'react';
import { IconProps } from './model/IconInterface';

const SkypeIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="12" cy="12" r="9" /><path d="M15 9.2A3.2 3.2 0 0 0 12 7c-1.7 0-3 1-3 2.3 0 2.9 6 1.6 6 4.5 0 1.3-1.3 2.3-3 2.3a3.2 3.2 0 0 1-3-2.2" />
    </svg>
  );
};

export default SkypeIcon;
